<template>
  <div>
    <!-- start: page -->
    <div class="row mb-xl-2">
      <div class="col-12 col-md-4 mb-3">
        <orders-card />
      </div>
      <div class="col-12 col-md-4 mb-3">
        <average-price />
      </div>
      <div class="col-12 col-md-4 mb-3">
        <users-card />
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12 col-xl-6 mb-3 mb-xl-0">
        <revenue />
      </div>
      <div class="col-12 col-xl-6">
        <top-selling-articles />
      </div>
    </div>
    <div class="row">
      <orders-by-location />
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <recent-orders />
      </div>
      <!-- end: page -->
    </div>
  </div>
</template>

<script>
import RecentOrders from './dashboard/RecentOrders.vue';
import OrdersByLocation from './dashboard/OrdersByLocation.vue';
import TopSellingArticles from './dashboard/TopSellingArticles.vue';
import Revenue from './dashboard/Revenue.vue';
import AveragePrice from './dashboard/AveragePrice.vue'
import UsersCard from './dashboard/UsersCard.vue';
import OrdersCard from './dashboard/OrdersCard.vue';

export default {
  name: 'Dashboard',
  components: {
    RecentOrders,
    OrdersByLocation,
    TopSellingArticles,
    Revenue,
    AveragePrice,
    UsersCard,
    OrdersCard,
  },
  mounted() {
    this.$store.dispatch('getDashboardData');
  },
}
</script>
